module.exports = __webpack_public_path__ + "static/profil-349_optimized-f28690e5a18563e43c86c842e824db5a.jpg";